import { Box } from "@mui/material";
import React from "react";
import useTheme from "../../../../../../../common/hooks/useTheme";
import { Theme } from "../../../../../../../providers/ThemeProvider";

type Props = {
  label1: string;
  label2: string;
  value1: number;
  value2: number;
};

/**
 * The mobile `BarCardTwoFactor`: two labels over a split bar (primary for the
 * first share, success for the rest) with the two percentages under it. A
 * zero share greys its label and value.
 */
const BarCardTwoFactor = ({ label1, label2, value1, value2 }: Props) => {
  const theme: Theme = useTheme();
  return (
    <Box sx={styles.container(theme)}>
      <Box sx={styles.row}>
        <Box sx={styles.label(theme, value1 === 0)}>{label1}</Box>
        <Box sx={styles.label(theme, value2 === 0)}>{label2}</Box>
      </Box>
      <Box sx={styles.bar(theme)}>
        <Box sx={styles.fill(theme, Math.max(0, Math.min(100, value1)))} />
      </Box>
      <Box sx={styles.row}>
        <Box sx={styles.value(theme, value1 === 0)}>{value1}%</Box>
        <Box sx={styles.value(theme, value2 === 0)}>{value2}%</Box>
      </Box>
    </Box>
  );
};

export default BarCardTwoFactor;

const styles = {
  container: (theme: Theme) => ({
    padding: "12px",
    borderRadius: "8px",
    border: `1px solid ${theme.colors_ds.NEUTRAL_BORDER_WEAK}`,
    backgroundColor: theme.colors_ds.NEUTRAL_BG_MAIN,
  }),
  row: {
    display: "flex",
    justifyContent: "space-between",
  },
  bar: (theme: Theme) => ({
    height: "6px",
    margin: "8px 0",
    borderRadius: "38px",
    backgroundColor: theme.colors_ds.SUCCESS_ICON_MAIN,
    overflow: "hidden",
  }),
  fill: (theme: Theme, percent: number) => ({
    height: "6px",
    width: `${percent}%`,
    borderRadius: "38px",
    backgroundColor: theme.colors_ds.PRIMARY_GRAPH_MAIN,
  }),
  label: (theme: Theme, muted: boolean) => ({
    color: muted ? theme.colors_ds.NEUTRAL_TEXT_WEAK : theme.colors_ds.NEUTRAL_TEXT_STRONG,
    fontFamily: "var(--font-Regular)",
    fontSize: "14px",
    lineHeight: "20px",
  }),
  value: (theme: Theme, muted: boolean) => ({
    color: muted ? theme.colors_ds.NEUTRAL_TEXT_WEAK : theme.colors_ds.NEUTRAL_TEXT_STRONG,
    fontFamily: "var(--font-Bold)",
    fontSize: "14px",
    lineHeight: "20px",
  }),
};
